// @flow

import React from 'react';
import styled from 'styled-components';
import { bottomPadding, flex, topPadding } from 'styles';
import { BlockyContentItems } from 'templates';
import { AbsoluteBackground } from 'components/Gui';

const Wrapper = styled.section`
  position: relative;
  ${flex()};
  flex-direction: column;
  ${({ paddingTop }) => topPadding(...paddingTop)};
  ${({ paddingBottom }) => paddingBottom && bottomPadding(...paddingBottom)};
`;

type Props = {
  paddingTop?: number[],
  paddingBottom?: number[],
  background?: string,
  content: any[],
};

const BlockyVerticalSection = ({ paddingTop = [84, 152, 152], paddingBottom, background, content, ...rest }: Props) => (
  <Wrapper paddingTop={paddingTop} paddingBottom={paddingBottom} {...rest}>
    {background && <AbsoluteBackground background={background} />}
    {content.map((itemContent, index) => (
      <BlockyContentItems key={`BlockyVerticalSection-${index}`} {...rest} {...itemContent} />
    ))}
  </Wrapper>
);

BlockyVerticalSection.contentType = 'BlockyVerticalSection';

export default BlockyVerticalSection;
